import { translationTestPortals_da } from "./translationTestPortals.da";
import { defineDashboardTranslations } from "./translationTypes";
import { translationTestPortals_en } from "./translationTestPortals.en";
import { translationTestPortals_sv } from "./translationTestPortals.sv";

export const translationTestPortals = defineDashboardTranslations({
  da: translationTestPortals_da,
  en: translationTestPortals_en,
  sv: translationTestPortals_sv,
});
